let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dZxlR")).then(() => parcelRequire('gTjY8'));